'use strict';

import ready from './lib/ready';

import {delegate, trigger} from './lib/events';
import {mutate} from './lib/promise-fastdom';
import promiseIdle from './lib/promise-idle';
import ToggleArea from './lib/ToggleArea';
import focusElement from './lib/focus-element';
import {ButtonBehavior} from './lib/ToggleArea_ButtonBehavior';
import FocusJail from './lib/FocusJail';

ready()
    .then(promiseIdle())
    .then(mutate(function () {

        const root = document.documentElement;
        const button = document.querySelector('.search-toggle');
        const close = document.querySelector('.searchform__close');
        const area = document.getElementById('search');
        const input = document.getElementById('search-input');

        let search;
        let ready = Promise.resolve().then(mutate(function () {
            button.role = 'button';
            button.setAttribute('href', '#');
            close.role = 'button';
            close.setAttribute('href', '#');
        }));

        // #search link
        document.addEventListener('click', delegate('a[href="#search"]', function (e) {
            if (!search) {
                e.preventDefault();
                focusElement.call(area, true);
            }
        }));

        close.addEventListener('click', function (e) {
            if (!search) {
                return;
            }
            e.preventDefault();
            focusElement.call(button, true);
            trigger.call(button, 'click');
        });

        document.addEventListener('search/before-open', mutate(function () {
            root.classList.add('search-on');
        }), {passive: true});
        document.addEventListener('search/after-open', mutate(function () {
            focusElement.call(input, true);
        }), {passive: true});
        document.addEventListener('search/before-close', mutate(function () {
            root.classList.remove('search-on');
        }), {passive: true});

        ready.then(() => {
            search = new ToggleArea(area, 'search', [
                new ButtonBehavior(button, {
                    closeOnEsc: true,
                    closeOnOutsideClick: false,
                    closeOnLinkClick: false,
                    jail: new FocusJail([area]),
                }),
            ]);
        });
    }));